<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    version="1.1"
    id="Capa_1"
    x="0px"
    y="0px"
    width="12px"
    height="12px"
    viewBox="0 0 433.5 433.5"
    style="enable-background: new 0 0 433.5 433.5"
    xml:space="preserve"
  >
    <g>
      <g id="file-download">
        <path
          d="M395.25,153h-102V0h-153v153h-102l178.5,178.5L395.25,153z M38.25,382.5v51h357v-51H38.25z"
        ></path>
      </g>
    </g>
  </svg>
</template>
